module.exports = __webpack_public_path__ + "static/media/bluemood.8dae416b.jpeg";